


















import { Spinner } from '@front/ui'

export default {
  components: {
    Spinner,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
}
